import React, { FC } from "react";
import { FeeWithDiscount } from "../../../Pricing/FeeWithDiscount.csharp";
import classNames from "classnames";
import { formatPrice } from "../../Helpers/priceHelper";

interface FeeWithDiscountTableProps {
  heading: string;
  fees: FeeWithDiscount[];
  highlightPriceRowOnHover: boolean;
  getPrice: (fee: FeeWithDiscount) => number;
  getDiscount: (fee: FeeWithDiscount) => number;
  showHeading?: boolean;
}

export const FeeWithDiscountTable: FC<FeeWithDiscountTableProps> = ({
  heading,
  fees,
  highlightPriceRowOnHover,
  getPrice,
  getDiscount,
  showHeading = true,
}) => {
  return fees.length > 0 ? (
    <div className="FeeWithDiscountTable">
      {showHeading && (
        <div
          className="FeeWithDiscountTable__heading"
        >
          {heading}
        </div>
      )}
      <table>
        <tbody>
          {fees.map((fee, i) => {
            const price = getPrice(fee);
            const discount = getDiscount(fee);

            return (
              <tr
                key={i}
                className={classNames("FeeWithDiscountTable__detailsRow", {
                  "FeeWithDiscountTable__detailsRow--highlightedOnHover":
                    highlightPriceRowOnHover && !fee.applyHeadingStyle,
                })}
              >
                <th
                  className={classNames({
                    "FeeWithDiscountTable__featuredFeeLabel": fee.applyHeadingStyle,
                  })}
                >
                  {fee.label}
                </th>
                {(price != 0 || fee.useFromPrefix) && (
                  <td className="FeeWithDiscountTable__price">
                    {!!discount && (
                      <span className="FeeWithDiscountTable__price--old">
                        {formatPrice(price)}
                      </span>
                    )}
                    {fee.useFromPrefix
                      ? formatPrice(!!fee.minPrice ? fee.minPrice : price, true)
                      : formatPrice(price - discount)}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  ) : null;
};
